import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( '.image-content-card-collage' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 80%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-content-card-collage', COMPONENT );
} )( app );
